import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59b6be4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden md:block" }
const _hoisted_2 = { class: "font-medium capitalize" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "9",
  viewBox: "0 0 15 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mt-1"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L7.5 7.5L14 1",
    stroke: "#000000",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "w-[30rem] bg-white absolute mt-3 pt-4 px-8 pb-4 right-16 shadow"
}
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close select your language", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  class: "w-4 h-4"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.4 19.2a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zm19.2 0a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zM7.4 14a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zm9 0a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zM12 9.6a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zM16.4 5a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zm-9 0a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zm14.2-5a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zM2.4 0a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8z",
    fill: "currentColor"
  })
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "mb-8 text-3xl font-medium" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "font-medium capitalize" }
const _hoisted_12 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.26.481a.964.964 0 0 1 0 1.407l-8 8a.964.964 0 0 1-1.406 0l-4-4a.964.964 0 0 1 0-1.407.964.964 0 0 1 1.407 0l3.281 3.282L12.855.48a.964.964 0 0 1 1.406 0Z",
  fill: "#000"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  setup(__props) {

const { locale } = useI18n({
  useScope: "global",
});

const isLanguageMenuOpen = ref(false);

const { user } = storeToRefs(useUserStore());
const { currentLanguage, languages } = storeToRefs(useGlobalStore());

/** Set the pi-lang cookie */
function setCookie(cname: string, val: string) {
  document.cookie = `${cname}=${val};domain=.playincluded.com;path=/;expires=Fri, 31 Dec 9989 23:59:59 GMT;SameSite=None;Secure=;`;
}

/** Get the pi-lang cookie */
function getCookie(cname: string) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/** Set the chosen language from dropdown menu */
function setLang(lang: any) {
  currentLanguage.value = lang;
  locale.value = lang.locale;
  document.documentElement.lang = lang.locale || "en";
  isLanguageMenuOpen.value = false;

  setCookie("pi-lang", lang.locale === "en" ? "" : lang.locale);
  updateUserLang(lang);

  window.location.reload();
}

/** Save the chosen language to user's profile */
async function updateUserLang(lang: any) {
  return await api.users.updateUserLanguage(user.value.id, {
    language: lang.locale,
  });
}

/** Set the Service Portal Language */
onMounted(async () => {
  let cookieLang = getCookie("pi-lang");

  /** Check if cookie exists */
  if (cookieLang) {
    const lang = languages.value.find(i => i.locale === getCookie("pi-lang"))!;
    currentLanguage.value = lang;
    locale.value = lang.locale;

    /** Check if user's language is different from the cookie */
    if (cookieLang !== user.value.language) {
      updateUserLang(currentLanguage.value);
    }
  }

  if (!getCookie("pi-lang")) {
    // Set the cookie to the current language of User account
    let userLang = user.value?.language ? user.value?.language : "en";
    const lang = languages.value.find(i => i.locale === userLang)!;
    currentLanguage.value = lang;
    locale.value = lang.locale;

    setCookie("pi-lang", currentLanguage.value?.locale !== "en" ? currentLanguage.value?.locale : "");
  }

  document.documentElement.lang = cookieLang || "en";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isLanguageMenuOpen.value = !isLanguageMenuOpen.value)),
      class: "flex items-center space-x-2 hover:underline fancy-link-hover"
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t(_unref(currentLanguage).region ?? 'english')), 1),
        _createTextVNode(" - " + _toDisplayString(_ctx.$t(_unref(currentLanguage).name ?? 'english')), 1)
      ]),
      _hoisted_3
    ]),
    (isLanguageMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isLanguageMenuOpen.value = false))
            }, _hoisted_8)
          ]),
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("select-your-language")), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (lang, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "mb-4",
                key: index
              }, [
                _createElementVNode("button", {
                  class: "flex items-center space-x-2 text-lg hover:underline",
                  onClick: ($event: any) => (setLang(lang))
                }, [
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t(lang.region)), 1),
                    _createTextVNode(" - " + _toDisplayString(_ctx.$t(lang.name)), 1)
                  ]),
                  (_unref(currentLanguage).locale === lang.locale)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})